const API_URL = '/api'
export const PROGRAMS_URL = `${API_URL}/programs`

// PROGRAMS
export const PROGRAMS_PASSWORD_URL = `${PROGRAMS_URL}/auth/`
